<template>
  <v-app>
    <v-main class="align-center px-md-10 py-6 py-md-10 py-lg-16">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  beforeCreate() {
    document.title = this.$route.name;
  },
};
</script>

<style>
.v-main {
  background-image: url(/img/bg.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
